export enum PageEnum {
    Unknown = 0,
    Otp = 1,
    AddBankAccount = 2,
    Deposit = 3,
    History = 4,
    Withdraw = 5,
    WithdrawProcessing = 6,
    PromotionProgress = 7,
    WithdrawReachLimit = 8,
    PromotionPendingDeposit = 9,
    Cpf = 10,
    DepositBeforeWithdraw = 11,
    KycPending = 12,
    WithdrawNoAvailablePayment = 13,
    Temp = 999, // for dev use
}

/**
 * Parse a string or route name to PageEnum
 * @param routeName - Route name (e.g., 'deposit', 'withdraw') or any value
 * @returns PageEnum value, or PageEnum.Unknown if not found
 */
export function parsePageEnum(routeName: string | symbol | null | undefined): PageEnum {
    if (!routeName || typeof routeName !== 'string') {
        return PageEnum.Unknown
    }

    // Route names are lowercase enum names (e.g., 'deposit', 'withdraw')
    // Find matching enum value by comparing case-insensitive names
    const enumKey = Object.keys(PageEnum).find(
        key => Number.isNaN(Number(key)) && key.toLowerCase() === routeName.toLowerCase(),
    )

    if (enumKey) {
        return PageEnum[enumKey as keyof typeof PageEnum]
    }

    return PageEnum.Unknown
}
